<template src="./AddConfiguration.html"></template>

<script>
import {notify, notifyApiError, notifyError} from "@/utils/notification-helper";
import { MESSAGES } from "@/utils/constants";
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("configuration");
export default {
  data: function () {
    return {
      add: this.$route.params.add,
      configurationData: {},
      expand: true,
      name: null,
      defaultDB: false,
      sharedDB: false,
      description: null,
    }
  },
  methods: {
    goToListPage: function () {
      this.$store.commit("configuration/cancel");
      this.$router.push({ name: "configuration" });
    },
    expandPanel() {
      let header = document.querySelectorAll("#panelbar .k-header");
      let element = document.querySelectorAll("#panelbar .k-content")[0];
      element.setAttribute("style", "display:block !important");
      header[0].addEventListener("click", () => {
        if (element.getAttribute("style") == "display: block;") {
          element.setAttribute("style", "display:none !important");
        }
      });
    },
    async getDataOnload() {
      if (!this.$route.params.add) {
        this.title = "Update Configuration";
        this.deviceEditData = this.$store.getters["configuration/getEditConfiguration"];
        this.name= this.deviceEditData.name
        this.description= this.deviceEditData.description,
        this.defaultDB= this.deviceEditData.isDefault,
        this.sharedDB= this.deviceEditData.isSharedDb
      }
    },
    clearEntries: function () {
      this.name= null,
      this.description= null,
      this.defaultDB= false,
      this.sharedDB= false
    },
    addConfiguration: function () {
      if(this.name && this.description) {
        this.configurationData= {
          tenantId: this.$store.state.tenantID,
          Name: this.name,
          Description : this.description,
          IsDefault: this.defaultDB==="true"? true: false,
          IsSharedDb: this.sharedDB==="true"? true: false,
        };
        if (this.add) {
          this.$store
          .dispatch("configuration/addConfiguration", this.configurationData)
          .then((data) => {
            console.log("Data : ",data)
            // if (data.success) {
              notify(MESSAGES.RECORD_CREATE_SUCCESS);
              this.goToListPage();
              this.clearEntries();
            // } else {
            //   notifyWarn(data.message);
            // }
          })
          .catch((err) => {
            try {
              notifyError(err.response.data.message);
            } catch (error) {
              notifyApiError({ message: "Something went wrong" });
            }
          });
        } else {
          this.$store
          .dispatch("configuration/updateConfiguration", this.configurationData)
          .then((data) => {
            console.log("Data : ",data)
            // if(data.status) {
              notify(MESSAGES.CHANGES_SAVE_SUCCESS);
              this.goToListPage();
              this.clearEntries();
            // }else {
            //   notifyWarn(data.message);
            // }
          }).catch(notifyApiError);
        }
      }
    }
  },
  computed: {

  },
  mounted() {
    this.expandPanel();
    this.getDataOnload()
  },
}
</script>
<style lang="scss" scoped>
@import url("https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css");
@media only screen and (max-width: 768px) {
  .k-form,
  .k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
    padding: 1rem !important;
  }
  .page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
  }
  .mobile_side_lbl {
    width: 70% !important;
  }
  .mobile_side_btn {
    display: flex;
  }
  .driver_header_mobile {
    flex-direction: row !important;
    overflow-x: auto;
    padding: 10px 10px 10px 10px;
  }
}
.multiselect__tags {
  display: block;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 12px;
}
</style>